import { Validator } from 'vee-validate'
import { validaEmail, validaEmailEstrito } from '@/shared/common/functions/texto'

Validator.localize('pt');

Validator.extend('email', {
    getMessage: 'Digite um e-mail válido',
    validate: ((email) => {
        return validaEmail(email)
    })
});

Validator.extend('email-estrito', {
    getMessage: 'Digite um e-mail válido (ex.: usuario@dominio.com.br)',
    validate: ((email) => {
        return validaEmailEstrito(email)
    })
});
